import { getTranslations } from '../translations/index.js';
import { version } from '../version.js';

const [ MAJOR_VERSION ] = version.split('.');
const TRANSLATION_PREFIX = 'pr-document-visualizations__media-type--';

export const MediaTypes = {
    bilibili: 'bilibili',
    douyin: 'douyin',
    facebook: 'facebook',
    instagram: 'instagram',
    linkedin: 'linkedin',
    news: 'news',
    pinterest: 'pinterest',
    podcasts: 'podcasts',
    premium: 'premium',
    reddit: 'reddit',
    'social_blogs': 'social_blogs',
    'social_comments': 'social_comments',
    'social_message_boards': 'social_message_boards',
    'social_reviews': 'social_reviews',
    tiktok: 'tiktok',
    'tveyes_radio': 'tveyes_radio',
    'tveyes_television': 'tveyes_television',
    twitch: 'twitch',
    twitter: 'twitter',
    unknown: 'unknown',
    wechat: 'wechat',
    weibo: 'sina_weibo',
    youku: 'youku',
    youtube: 'youtube'
};

export function getMediaType(document) {
    const { mediaType, subMediaType, isHosted } = document;

    if (!mediaType) {
        return MediaTypes.unknown;
    } else if (isHosted) {
        return MediaTypes.premium;
    } else if (mediaType === MediaTypes.news && subMediaType === MediaTypes.weibo) {
        return MediaTypes.weibo;
    } else if (mediaType === MediaTypes.news && subMediaType === MediaTypes.wechat) {
        return MediaTypes.wechat;
    }

    return mediaType;
}

/**
 * @private
 */
export class MediaTypeTranslation extends HTMLElement {
    static get tagName() {
        return `pr-document-media-type-translation-${MAJOR_VERSION}`;
    }

    async connectedCallback() {
        const language = this.getAttribute('language');
        const translations = await getTranslations({ language });

        const mediaType = this.getAttribute('type');
        const translation = translations.getTranslation(`${TRANSLATION_PREFIX}${mediaType}`);
        const textNode = document.createTextNode(translation);

        this.replaceWith(textNode);
    }
}

if (!customElements.get(MediaTypeTranslation.tagName)) {
    customElements.define(MediaTypeTranslation.tagName, MediaTypeTranslation);
}
